import { GOOGLE_DRIVE_API_KEY } from '../../../../constants/Constants';
import Toast from '../../utils/Toast';

const loadPickerApi = () =>
  new Promise((resolve, reject) => {
    window.gapi.load('picker', {
      callback: () => {
        resolve();
      },
      onerror: () => {
        reject(new Error('Failed to load Google Picker API.'));
      },
    });
  });

const googleDriveFolderPath = async (accessToken) => {
  try {
    await loadPickerApi();
  } catch (error) {
    Toast({
      message: `Failed to load Google Picker API. ${error?.message}`,
      variant: 'error',
    });
    return;
  }

  return new Promise((resolve) => {
    const view = new window.google.picker.DocsView(
      window.google.picker.ViewId.FOLDERS,
    )
      .setSelectFolderEnabled(true)
      .setMimeTypes('application/vnd.google-apps.folder');

    const googleDrivePicker = new window.google.picker.PickerBuilder()
      .addView(view)
      .setOAuthToken(accessToken)
      .setDeveloperKey(GOOGLE_DRIVE_API_KEY)
      .enableFeature(window.google.picker.Feature.NAV_HIDDEN) // Hide navigation pane
      .hideTitleBar() // Hide the title bar to make it a modal dialog
      .setCallback((data) => {
        if (data.action === window.google.picker.Action.PICKED) {
          const folder = data.docs[0];
          resolve(folder);
        }
      })
      .build();

    googleDrivePicker.setVisible(true);
  });
};

export default googleDriveFolderPath;
